import { render, staticRenderFns } from "./VueDataTablePagination.vue?vue&type=template&id=20fbc7b5&scoped=true"
import script from "./VueDataTablePagination.vue?vue&type=script&lang=js"
export * from "./VueDataTablePagination.vue?vue&type=script&lang=js"
import style0 from "./VueDataTablePagination.vue?vue&type=style&index=0&id=20fbc7b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20fbc7b5",
  null
  
)

export default component.exports